import { useState } from 'react';
import { IconRail } from './IconRail';
import { HomeView, type HomeNavigateOptions } from './HomeView';
import { ChatView } from './chat/ChatView';
import { DocumentsView } from './documents/DocumentsView';
import { ReportsView } from './reports/ReportsView';
import { WorkflowsView } from './workflows/WorkflowsView';
import { DashboardsView } from './dashboards/DashboardsView';
import { SettingsView } from './SettingsView';
import { FEATURES } from '@/config/features';
import type { AITool } from './types';

export function AISidebar() {
  const [activeTool, setActiveTool] = useState<AITool>('home');
  const [openConversationId, setOpenConversationId] = useState<number | null>(null);

  const handleToolChange = (tool: AITool, options?: HomeNavigateOptions) => {
    if (tool === 'documents' && !FEATURES.documents) return;
    setOpenConversationId(options?.conversationId ?? null);
    setActiveTool(tool);
  };

  const renderContent = () => {
    switch (activeTool) {
      case 'home':
        return <HomeView onNavigate={handleToolChange} />;
      case 'dashboard':
        return <DashboardsView />;
      case 'chat':
        return <ChatView initialConversationId={openConversationId} />;
      case 'documents':
        return FEATURES.documents ? <DocumentsView /> : <HomeView onNavigate={handleToolChange} />;
      case 'reports':
        return <ReportsView initialReportId={openConversationId} />;
      case 'workflows':
        return <WorkflowsView />;
      case 'settings':
        return <SettingsView />;
    }
  };

  return (
    <div className="flex h-screen w-full min-h-0 bg-background">
      <IconRail activeTool={activeTool} onToolChange={(tool) => handleToolChange(tool)} />
      <div className="min-h-0 flex-1 overflow-hidden">{renderContent()}</div>
    </div>
  );
}
